export default __webpack_public_path__ + "static/media/waste.f25b21dc.png";